const HouseLabelCircledIcon = props => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#F4EFED" />
    <path
      d="M20.2246 7L20.7127 6.43056L20.2358 6.02179L19.7497 6.41953L20.2246 7ZM9.22461 16L8.74968 15.4195L8.47461 15.6446V16H9.22461ZM30.7246 16H31.4746V15.655L31.2127 15.4306L30.7246 16ZM30.7246 31V31.75H31.4746V31H30.7246ZM25.2246 31H24.4746V31.75H25.2246V31ZM15.2246 31V31.75H15.9746V31H15.2246ZM9.22461 31H8.47461V31.75H9.22461V31ZM19.7497 6.41953L8.74968 15.4195L9.69954 16.5805L20.6995 7.58047L19.7497 6.41953ZM31.2127 15.4306L20.7127 6.43056L19.7365 7.56944L30.2365 16.5694L31.2127 15.4306ZM31.4746 31V16H29.9746V31H31.4746ZM25.2246 31.75H30.7246V30.25H25.2246V31.75ZM24.4746 24V31H25.9746V24H24.4746ZM20.2246 19.75C22.5718 19.75 24.4746 21.6528 24.4746 24H25.9746C25.9746 20.8244 23.4002 18.25 20.2246 18.25V19.75ZM15.9746 24C15.9746 21.6528 17.8774 19.75 20.2246 19.75V18.25C17.049 18.25 14.4746 20.8244 14.4746 24H15.9746ZM15.9746 31V24H14.4746V31H15.9746ZM9.22461 31.75H15.2246V30.25H9.22461V31.75ZM8.47461 16V31H9.97461V16H8.47461Z"
      fill="#0D0D0D"
    />
    <path d="M9.22461 15.8574H30.7746" stroke="#0D0D0D" strokeWidth="1.5" />
  </svg>
);

export default HouseLabelCircledIcon;
